export default {
  shareholders: `profile/shareholders`,
  update: `profile/shareholders/update`,
  remove: `profile/shareholders/remove`,
};
